import Vuex from 'vuex'
import home from '@/views/home/store/index'
import login from '@/views/login/store/index'
import produceTypeManage from '@/views/produceTypeManage/store/index'
import produceManage from '@/views/produceManage/store/index'
import hotelManage from '@/views/hotelManage/store/index'
import screenManage from '@/views/screenManage/store/index'
import consultation from '@/views/consultation/store/index'
import setting from '@/views/setting/store/index'
import medicalprojectmanage from '@/views/medicalProjectManage/store/index'
import orgmanage from '@/views/orgManage/store/index'
import staffmanage from '@/views/staffManage/store/index'
import tourmanage from '@/views/tourManage/store/index'
import farmermanage from '@/views/farmerManage/store/index'
import serviceStaff from '@/views/serviceStaff/store/index'
import postulant from '@/views/postulant/store/index'
import appointment from '@/views/appointment/store/index'
import dictmanage from '@/views/dictManage/store/index'
import rolemanage from '@/views/roleManage/store/index'
import permissionmanage from '@/views/permissionManage/store/index'
import equipmentTypeManage from '@/views/equipmentTypeManage/store/index'
import serverTypeManage from '@/views/serverTypeManage/store/index'
import restudentManage from '@/views/RestudentManage/store/index'

export function createStore (Vue) {
  Vue.use(Vuex)
  return new Vuex.Store({
    modules: {
      login: {
        ...login
      },
      home: {
        ...home
      },
      produceTypeManage: {
        ...produceTypeManage
      },
      produceManage: {
        ...produceManage
      },
      hotelManage: {
        ...hotelManage
      },
      screenManage: {
        ...screenManage
      },
      consultation: {
        ...consultation
      },
      setting: {
        ...setting
      },
      medicalprojectmanage: {
        ...medicalprojectmanage
      },
      orgmanage: {
        ...orgmanage
      },
      staffmanage: {
        ...staffmanage
      },
      tourmanage: {
        ...tourmanage
      },
      farmermanage: {
        ...farmermanage
      },
      serviceStaff: {
        ...serviceStaff
      },
      postulant: {
        ...postulant
      },
      appointment: {
        ...appointment
      },
      dictmanage: {
        ...dictmanage
      },
      rolemanage: {
        ...rolemanage
      },
      permissionmanage: {
        ...permissionmanage
      },
      equipmentTypeManage: {
        ...equipmentTypeManage
      },
      serverTypeManage: {
        ...serverTypeManage
      },
      restudentManage: {
        ...restudentManage
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js